import { createAsyncThunk } from "@reduxjs/toolkit";
import { IProductRequestView } from "../../modules/products/models/IProductRequestView";
import { ProductService } from "../../modules/products/services/productService";
import { IProductView } from "../../modules/products/models/IProductView";
import { IProductResponseView } from "../../modules/products/models/IProductResponseView";
import { AuthUtil } from "../../utils/AuthUtil";

/**
 * Create A Product
 */
export const createProductAction: any = createAsyncThunk(
  "products/createProductAction",
  async (
    payload: { product: IProductRequestView },
    { rejectWithValue }
  ): Promise<{ data: IProductView; msg: string; status: string } | any> => {
    try {
      if (AuthUtil.setTokenToRequestHeader()) {
        const { product } = payload;
        const response = await ProductService.createProduct(product);
        return response.data;
      }
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

/**
 *  Update a Product
 */
export const udpateProductAction: any = createAsyncThunk(
  "products/udpateProductAction",
  async (
    payload: { product: IProductRequestView; productId: string },
    { rejectWithValue }
  ): Promise<{ data: IProductView; msg: string; status: string } | any> => {
    try {
      if (AuthUtil.setTokenToRequestHeader()) {
        const { product, productId } = payload;
        const response = await ProductService.udpateProduct(product, productId);
        return response.data;
      }
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

/**
 * Get All Products
 */
export const getAllProductsAction: any = createAsyncThunk(
  "products/getAllProductsAction",
  async (
    payload: {},
    { rejectWithValue }
  ): Promise<
    { data: IProductResponseView[]; msg: string; status: string } | any
  > => {
    try {
      if (AuthUtil.setTokenToRequestHeader()) {
        const response = await ProductService.getAllProducts();
        return response.data;
      }
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

/**
 *  Get a Product
 */
export const getProductAction: any = createAsyncThunk(
  "products/getProductAction",
  async (
    payload: { productId: string },
    { rejectWithValue }
  ): Promise<
    { data: IProductResponseView; msg: string; status: string } | any
  > => {
    try {
      if (AuthUtil.setTokenToRequestHeader()) {
        const { productId } = payload;
        const response = await ProductService.getProduct(productId);
        return response.data;
      }
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

/**
 * Get All Products with Category ID
 */
export const getAllProductsWithCategoryIdAction: any = createAsyncThunk(
  "products/getAllProductsWithCategoryIdAction",
  async (
    payload: { categoryId: string },
    { rejectWithValue }
  ): Promise<
    { data: IProductResponseView[]; msg: string; status: string } | any
  > => {
    try {
      if (AuthUtil.setTokenToRequestHeader()) {
        const { categoryId } = payload;
        const response = await ProductService.getAllProductsWithCategoryId(
          categoryId
        );
        return response.data;
      }
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

/**
 * Delete a Product
 */
export const deleteProductAction: any = createAsyncThunk(
  "products/deleteProductAction",
  async (
    payload: { productId: string },
    { rejectWithValue }
  ): Promise<{ data: IProductView; msg: string; status: string } | any> => {
    try {
      if (AuthUtil.setTokenToRequestHeader()) {
        const { productId } = payload;
        const response = await ProductService.deleteProduct(productId);
        return response.data;
      }
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);
